/**
 * Created by portiz on 8/22/2018.
 */
import translateText from '../translations/global.json';

class LanguageManager {

    // Saves the language in the local storage
    static setLanguage(langCode){
        localStorage.setItem('lang', langCode);
    }

    // Returns the language form the local storage
    static getLanguage(defaultLanguage)
    {
        let langCode = localStorage.getItem('lang');
        if(langCode != null && langCode.length > 0)
            return langCode;
        else
            return defaultLanguage;
    }

    static getTranslation(key, languages){

        let index = key.indexOf(".");  // Gets the first index where a space occours
        let part = key.substr(0, index); // Gets the first part
        let subpart = key.substr(index + 1);  // Gets the text part

        // Now get the language
        let langCode = this.getLanguage("en");

        // Then find the language index by language code
        let indexLanguage = 0;
        for(let i=0; i < languages.length;i++)
        {
            if(languages[i].code === langCode) {
                indexLanguage = i;
                break;
            }
        }
        // We need the index to find the index in the translation
        return translateText[part][subpart][indexLanguage];
    }
}

export default LanguageManager;


// WEBPACK FOOTER //
// ./src/custom-classes/language-manager.js